// /payout-definitions
import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { Option } from '@/common/types';
import { API_URL } from '@/dtos';

export const QUERY_KEY = 'GET_PAYOUT_DEFINITIONS_PLAN';
export default (id?: string) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEY, id],
    id ? () => api.get(API_URL.PAYOUT_DEFINITIONS_PLANS_BY_ID(id)) : () => null
  );
  const planOptions = useMemo<Option[]>(() => {
    const list = data?.data || [];
    return list.map((item) => ({
      key: `${item.id}`,
      value: `${item.id}`,
      title: item.name || '',
    }));
  }, [data]);

  return {
    isLoading,
    planOptions,
  };
};
